var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tiptap-vuetify',{ref:"edt",attrs:{"value":_vm.value,"min_height":"800px","min_width":"320px","extensions":_vm.extensions,"label":"Notes","outlined":""},on:{"input":_vm.edt_input}})}
var staticRenderFns = []

export { render, staticRenderFns }